import { EventEmitter } from 'events';
import { readPacket, HEADER, assertPacket } from './atorch-packet';
const UUID_SERVICE = '0000ffe0-0000-1000-8000-00805f9b34fb';
const UUID_CHARACTERISTIC = '0000ffe1-0000-1000-8000-00805f9b34fb';
const DISCONNECTED = 'gattserverdisconnected';
const VALUE_CHANGED = 'characteristicvaluechanged';
const EVENT_FAILED = 'failed';
const EVENT_PACKET = 'packet';
export class AtorchService {
    constructor(device) {
        this.blocks = [];
        this.events = new EventEmitter();
        this.getCharacteristic = async () => {
            var _a;
            const server = await ((_a = this.device.gatt) === null || _a === void 0 ? void 0 : _a.connect());
            const service = await (server === null || server === void 0 ? void 0 : server.getPrimaryService(UUID_SERVICE));
            return service === null || service === void 0 ? void 0 : service.getCharacteristic(UUID_CHARACTERISTIC);
        };
        this.handleValueChanged = (event) => {
            var _a, _b;
            const target = event.target;
            const payload = Buffer.from((_b = (_a = target.value) === null || _a === void 0 ? void 0 : _a.buffer) !== null && _b !== void 0 ? _b : []);
            if (payload.indexOf(HEADER) === 0) {
                if (this.blocks.length !== 0) {
                    this.emitBlock(Buffer.concat(this.blocks));
                }
                this.blocks = [payload];
            }
            else {
                this.blocks.push(payload);
            }
        };
        this.device = device;
        device.addEventListener(DISCONNECTED, () => {
            this.events.emit('disconnected', false);
        });
    }
    static async requestDevice() {
        const device = await navigator.bluetooth.requestDevice({
            filters: [{ services: [UUID_SERVICE] }],
        });
        return new AtorchService(device);
    }
    async connect() {
        const characteristic = await this.getCharacteristic();
        characteristic === null || characteristic === void 0 ? void 0 : characteristic.addEventListener(VALUE_CHANGED, this.handleValueChanged);
        await (characteristic === null || characteristic === void 0 ? void 0 : characteristic.startNotifications());
    }
    async disconnect() {
        var _a;
        try {
            (_a = this.device.gatt) === null || _a === void 0 ? void 0 : _a.disconnect();
        }
        catch {
            // ignore
        }
        this.events.removeAllListeners();
    }
    async sendCommand(block) {
        assertPacket(block, 17 /* Command */);
        const characteristic = await this.getCharacteristic();
        await (characteristic === null || characteristic === void 0 ? void 0 : characteristic.writeValue(block));
    }
    on(event, listener) {
        this.events.on(event, listener);
        return () => {
            this.events.off(event, listener);
        };
    }
    emitBlock(block) {
        console.log('Block', block.toString('hex').toUpperCase());
        try {
            const packet = readPacket(block);
            this.events.emit(EVENT_PACKET, packet);
        }
        catch {
            this.events.emit(EVENT_FAILED, block);
        }
    }
}
